import { render, staticRenderFns } from "./ModalDialog.vue?vue&type=template&id=2ef7de21&scoped=true&"
import script from "./ModalDialog.vue?vue&type=script&lang=ts&"
export * from "./ModalDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ModalDialog.vue?vue&type=style&index=0&id=2ef7de21&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ef7de21",
  null
  
)

export default component.exports